/**
 * Single source of truth for the 4 curated reading journeys.
 * Used by:
 *   - CraftYourReadingJourney homepage section
 *   - JourneyLibraryPage at /journeys/:slug
 */
export const JOURNEYS = [
  {
    key: "aarohan",
    title: "Aarohan",
    hindi: "आरोहण",
    tagline: "The Ascent",
    description: "For those building themselves.",
    bookCount: "35+ BOOKS",
    motto: "EVERY GREAT TRANSFORMATION BEGINS WITH A SINGLE PATH.",
    books: [
      { title: "Atomic Habits",                            author: "James Clear",         isbn: "0735211299" },
      { title: "Deep Work",                                author: "Cal Newport",         isbn: "1455586691" },
      { title: "Can't Hurt Me",                            author: "David Goggins",       isbn: "1544512279" },
      { title: "The Mountain Is You",                      author: "Brianna Wiest",       isbn: "1949759229" },
      { title: "The 7 Habits of Highly Effective People",  author: "Stephen R. Covey",    isbn: "1451639619" },
    ],
  },
  {
    key: "nirmaan",
    title: "Nirmaan",
    hindi: "निर्माण",
    tagline: "Building Your Future",
    description: "For those building something bigger than themselves.",
    bookCount: "30+ BOOKS",
    motto: "BUILD. CREATE. LEAVE A LEGACY.",
    books: [
      { title: "The Lean Startup",            author: "Eric Ries",          isbn: "0307887898" },
      { title: "Zero to One",                 author: "Peter Thiel",        isbn: "0804139296" },
      { title: "Blue Ocean Strategy",         author: "W. Chan Kim",        isbn: "1625274491" },
      { title: "Good Strategy Bad Strategy",  author: "Richard Rumelt",     isbn: "0307886239" },
      { title: "Built to Last",               author: "Jim Collins",        isbn: "0060566108" },
    ],
  },
  {
    key: "nava-aarambh",
    title: "Nava Aarambh",
    hindi: "नव आरंभ",
    tagline: "New Beginnings",
    description: "For moments that demand reinvention.",
    bookCount: "20+ BOOKS",
    motto: "EVERY ENDING IS THE START OF SOMETHING MEANINGFUL.",
    books: [
      { title: "Designing Your Life",            author: "Bill Burnett",       isbn: "1101875321" },
      { title: "The Psychology of Money",        author: "Morgan Housel",      isbn: "0857197681" },
      { title: "Essentialism",                   author: "Greg McKeown",       isbn: "0804137382" },
      { title: "Ikigai",                         author: "Héctor García",      isbn: "0143130722" },
      { title: "The Almanack of Naval Ravikant", author: "Eric Jorgenson",     isbn: "1544514212" },
    ],
  },
  {
    key: "tattva",
    title: "Tattva",
    hindi: "तत्व",
    tagline: "Timeless Wisdom",
    description: "Ideas that remain true across generations.",
    bookCount: "25+ BOOKS",
    motto: "TRUTH IS TIMELESS. WISDOM IS TRANSFORMATIONAL.",
    books: [
      { title: "Bhagavad Gita",                author: "Eknath Easwaran",     isbn: "1586380192" },
      { title: "Man's Search for Meaning",     author: "Viktor E. Frankl",    isbn: "080701429X" },
      { title: "The Power of Now",             author: "Eckhart Tolle",       isbn: "1577314808" },
      { title: "The Courage to Be Disliked",   author: "Ichiro Kishimi",      isbn: "1501197274" },
      { title: "Think and Grow Rich",          author: "Napoleon Hill",       isbn: "1585424331" },
    ],
  },
];

export const journeyByKey = (k) => JOURNEYS.find((j) => j.key === k) || JOURNEYS[0];
